import React from 'react';

const isDevMode = process.env.REACT_APP_DEV_MODE === 'true';

const DevBanner = () => {
  if (!isDevMode) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10001,
        background: '#2E7D32',
        color: '#fff',
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textAlign: 'center',
        padding: '4px 0',
        userSelect: 'none',
      }}
    >
      DEV ENVIRONMENT
    </div>
  );
};

export const DEV_BANNER_HEIGHT = isDevMode ? 24 : 0;

export default DevBanner;
